module.exports = __webpack_public_path__ + "img/harga.6553d7f2.png";